export default __webpack_public_path__ + "static/09-b7ecf26acf7d80c516efe9494ff63a9f.jpg";